import Header from "@/components/Header";
import Sidebar from "@/components/Sidebar";
import { operatorStudentExchangeNavigations } from "@/constants";
import { useUser } from "@/hooks/useUser";
import { Navigate, Outlet } from "react-router-dom";

export default function OperatorStudentExchangeLayout() {
  const { user, isPending } = useUser();
  const userRoles = user?.jenis_user || [];
  const operatorStudentExchange =
    userRoles.includes("operator_studentexchange") || false;

  if (!isPending && !operatorStudentExchange) return <Navigate to={"/"} />;

  return (
    <main className="flex">
      <Sidebar navigationMenus={operatorStudentExchangeNavigations} />
      <section className="flex-1 overflow-x-auto p-5 min-h-screen">
        <Header />
        <Outlet />
      </section>
    </main>
  );
}
